  <modal
  [id]="modalId"
  [header]="modalHeaderTitle"
  [headerIcon]="modalHeaderIcon"
  [showHeader]="true"
  [showHeaderDivider]="true"
  [showFooterDivider]="false"
  [closeButtonEnabled]="true"
  [widthClass]="modalWidthClass"
  [heightClass]="modalHeightClass"
  [enableBackdropClose]="true"
  (onCloseModal)="onModalClose()"
>
  <div slot="body" class="tw-flex tw-flex-col tw-h-full tw-min-h-0 tw-font-inter" [ngClass]="{ 'tw-justify-start': isCompleteStep }">
    @if (showOptOutSummary) {
    <p class="tw-m-0 tw-mb-4 tw-font-medium tw-text-sm tw-leading-5 tw-text-gray-700">
      Can invite {{ optOutStatus.notOptOut }} / can't invite {{ optOutStatus.opt_out }}
    </p>
    }

    @if (shouldShowEventSearch) {
    <div class="tw-relative tw-w-full tw-mb-4 tw-shrink-0">
      <svg
        class="tw-absolute tw-start-3 tw-top-1/2 -tw-translate-y-1/2 tw-w-4 tw-h-4 tw-text-gray-400 tw-pointer-events-none"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        stroke-width="2"
        aria-hidden="true"
      >
        <circle cx="11" cy="11" r="8"></circle>
        <path d="m21 21-4.3-4.3"></path>
      </svg>
      <input
        type="text"
        [ngModel]="searchTerm"
        (ngModelChange)="onSearchTermChangedEvent($event)"
        placeholder="Search"
        class="tw-w-full tw-rounded-xl tw-border tw-border-gray-200 tw-bg-white tw-py-3 tw-ps-10 tw-pe-3.5 tw-text-base tw-text-gray-900 tw-outline-none focus:tw-border-blue-500 focus:tw-ring-1 focus:tw-ring-blue-500"
      />
    </div>
    }

    <div class="tw-relative tw-flex-1 tw-min-h-0 tw-overflow-hidden">
      @if (processing || (loadingBalance && flowStep === 'message')) {
      <div class="tw-absolute tw-inset-0 tw-z-10 tw-flex tw-items-center tw-justify-center tw-bg-white/60">
        <progress-circle colorClasses="tw-border-blue-500 tw-border-r-gray-300"></progress-circle>
      </div>
      } @if (flowStep === 'topup' && isMessageStep) {
      <div class="tw-overflow-y-auto tw-max-h-[70vh]">
        @defer (on immediate) {
        <app-billing-wallet-top-up-modal
          [embedded]="true"
          [active]="true"
          [initialCustomAmount]="suggestedTopUpAmount()"
          [paymentMethods]="paymentMethods"
          (topUpSuccess)="onWalletTopUpSuccess($event)"
          (cancelRequested)="backFromTopUp()"
        ></app-billing-wallet-top-up-modal>
        } @placeholder {
        <div class="tw-flex tw-justify-center tw-py-10">
          <progress-circle colorClasses="tw-border-blue-500 tw-border-r-gray-300"></progress-circle>
        </div>
        }
      </div>
      } @else if (isCompleteStep) {
      <div class="tw-flex tw-flex-col tw-gap-4 tw-items-start tw-w-full tw-text-left">
        <div class="tw-font-normal tw-text-sm sm:tw-text-base tw-leading-[1.5] tw-text-gray-700">
          @if (isCompleteStepEmpty) {
          <p class="tw-m-0 tw-leading-[1.5]">No entries were added. Every targeted entry was skipped.</p>
          <p class="tw-m-0 tw-leading-[1.5]">Review the reasons below.</p>
          } @else {
          <p class="tw-m-0 tw-leading-[1.5]">Your request has started successfully.</p>
          <p class="tw-m-0 tw-leading-[1.5]">
            <span class="tw-font-semibold">{{ addedEntriesCount | number }}</span>
            {{ addedEntriesCount === 1 ? 'entry is' : 'entries are' }} being added to the target persona collection. This may take some time to finish, but you
            can safely leave this screen.
          </p>
          }
        </div>
        @if (skippedSummaryRows.length) {
        <ul class="tw-m-0 tw-p-0 tw-list-none tw-flex tw-flex-col tw-gap-3 tw-w-full">
          @for (row of skippedSummaryRows; track row.label) {
          <li class="tw-flex tw-items-center tw-gap-2">
            <img src="assets/images/v2/invite/skip-x.svg" alt="" class="tw-w-2.5 tw-h-2.5 sm:tw-w-3 sm:tw-h-3 tw-shrink-0 tw-mt-0.5" width="12" height="12" />
            <span class="tw-font-medium tw-text-xs sm:tw-text-sm tw-leading-[1.5] tw-text-gray-500"> {{ row.count | number }} - {{ row.label }} </span>
          </li>
          }
        </ul>
        }
      </div>
      } @else {
      <div
        class="custom-scrollable-content tw-h-full tw-overflow-y-auto tw-scrollbar-none"
        [ngClass]="{ 'tw-flex tw-flex-col tw-min-h-0': isMessageStep }"
      >
        @if (isToEventStep || isFromEventStep) {
          @if (showNoEligibleEventsMessage) {
          <div class="tw-flex tw-items-center tw-justify-center tw-h-full tw-min-h-[200px] tw-px-4 tw-text-center">
            <p class="tw-m-0 tw-font-medium tw-text-sm sm:tw-text-base tw-leading-6 tw-text-gray-500">
              There are no upcoming or live events.
            </p>
          </div>
          } @else {
          <ngx-event-selection
            [events]="events"
            [shouldPaginate]="isFromEventStep"
            (eventSelected)="setEvent($event)"
            (loadNextPage)="nextPage($event)"
          ></ngx-event-selection>
          }
        }
        <div [ngClass]="{ 'tw-flex tw-flex-col tw-min-h-0': isToPersonaStep }">
          @if (isToPersonaStep || isFromPersonaStep) {
          <div class="tw-flex-1 tw-min-h-0">
            <ngx-persona-selection
              [personas]="personasList"
              [selectedPersona]="isToPersonaStep ? selectedToPersonaSlug : selectedFromPersonaSlug"
              (personaSelected)="setPersona($event)"
            >
            </ngx-persona-selection>
          </div>
          }
        </div>

      </div>
      }
    </div>
  </div>

  <div slot="footer" class="tw-px-6 tw-pb-6 lg:tw-pt-4 tw-pt-0">
    @if (flowStep !== 'topup') {
    @if (isToPersonaStep) {
    <div class="tw-flex tw-items-center">
      <button
        type="button"
        class="tw-inline-flex tw-justify-center tw-items-center tw-rounded-md tw-border tw-border-gray-300 tw-bg-white tw-px-5 tw-py-2.5 tw-font-medium tw-text-base tw-leading-6 tw-text-gray-800 tw-cursor-pointer hover:tw-bg-gray-50 disabled:tw-opacity-50 disabled:tw-cursor-not-allowed"
        (click)="back()"
      >
        Back
      </button>
    </div>
    }
    @if (isCompleteStep) {
    <div class="tw-flex tw-flex-col sm:tw-flex-row sm:tw-justify-end tw-gap-3 sm:tw-gap-4 tw-w-full">
      @if (isCompleteStepEmpty) {
      <button
        type="button"
        class="tw-w-full sm:tw-w-auto tw-inline-flex tw-justify-center tw-items-center tw-rounded-lg tw-bg-[#1C64F2] tw-px-5 sm:tw-px-6 tw-py-2.5 sm:tw-py-3.5 tw-font-medium tw-text-sm sm:tw-text-base tw-leading-[1.5] tw-text-white tw-cursor-pointer hover:tw-bg-blue-700 tw-transition-colors tw-h-10"
        (click)="closeModal()"
      >
        Done
      </button>
      } @else {
      <button
        type="button"
        class="tw-order-2 sm:tw-order-1 tw-w-full sm:tw-w-auto tw-inline-flex tw-justify-center tw-items-center tw-rounded-lg tw-border tw-border-gray-200 tw-bg-white tw-px-5 sm:tw-px-6 tw-py-2.5 sm:tw-py-3.5 tw-font-medium tw-text-sm sm:tw-text-base tw-leading-[1.5] tw-text-gray-800 tw-cursor-pointer hover:tw-bg-gray-50 tw-h-10"
        (click)="closeModal()"
      >
        Stay here
      </button>
      <button
        type="button"
        class="tw-order-1 sm:tw-order-2 tw-w-full sm:tw-w-auto tw-inline-flex tw-justify-center tw-items-center tw-rounded-lg tw-bg-[#1C64F2] tw-px-5 sm:tw-px-6 tw-py-2.5 sm:tw-py-3.5 tw-font-medium tw-text-sm sm:tw-text-base tw-leading-[1.5] tw-text-white tw-cursor-pointer hover:tw-bg-blue-700 tw-transition-colors tw-h-10"
        (click)="viewInvitationCollection()"
      >
        View collection
      </button>
      }
    </div>
    }
    }
  </div>
</modal>
